import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Facebook, Instagram, Youtube, ExternalLink } from 'lucide-react';


const NAV = [
  { label: 'Home', to: '/' },
  { label: 'News', to: '/news' },
  {
    label: 'About Us',
    to: '/about-us',
    children: [
      { label: 'About CIBA', to: '/about-us' },
      { label: 'History – Video', to: '/page/history-video' },
      { label: 'Objectives', to: '/page/objectives' },
      { label: 'Committees', to: '/page/committees' },
      { label: 'Code of Conduct', to: '/page/code-of-conduct' },
    ],
  },
  {
    label: 'Leagues & Programs',
    to: '/page/national-mens-basketball-league',
    children: [
      { label: "National Men's League", to: '/page/national-mens-basketball-league' },
      { label: "National Women's League", to: '/page/national-womens-league' },
      { label: 'Under 19 Leagues', to: '/page/under-19' },
      { label: 'Under 16 Leagues', to: '/page/under16' },
      { label: '15 & Under Leagues', to: '/page/ciba-15-under-boys-girls-basketball-leagues' },
      { label: '13 & Under Leagues', to: '/page/under-13' },
      { label: '10 & Under Leagues', to: '/page/under-10' },
      { label: 'Corporate League', to: '/page/corporate-basketball-league' },
      { label: 'Kings Development Program', to: '/page/kings-development-program' },
      { label: 'Basketball Academy', to: '/page/academy' },
      { label: 'Camps', to: '/page/camps' },
      { label: 'Training', to: '/page/training' },
      { label: 'Volunteer', to: '/volunteer' },
    ],
  },
  { label: 'Events', to: '/page/events' },
  { label: 'Results & Stats', to: '/results' },
  { label: 'Rules', to: '/page/rules-and-regulations' },
  { label: 'Sponsors', to: '/page/sponsors' },
  { label: 'Contact', to: '/contact-us' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openSub, setOpenSub] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setOpenSub(null);
  }, [location]);

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      {/* Top utility bar */}
      <div className="top-bar">
        <div className="container top-bar-inner">
          <span className="top-bar-tagline">The Home of Basketball in the Cayman Islands</span>
          <div className="top-bar-social">
            <a href="https://www.facebook.com/caymanbasketball" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={15} /></a>
            <a href="https://instagram.com/345basketball" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={15} /></a>
            <a href="https://www.youtube.com/@CaymanIslandsBasketball" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={15} /></a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="main-nav-wrap">
        <div className="container main-nav-inner">
          <Link to="/" className="brand">
            <img src="/ciba-logo.jpg" alt="CIBA Logo" className="brand-logo" />
            <div className="brand-text">
              <span className="brand-title">Cayman Islands</span>
              <span className="brand-sub">Basketball Association</span>
            </div>
          </Link>

          <nav className="desktop-nav">
            {NAV.map((item) => (
              <div key={item.label} className="nav-item">
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noreferrer" className="nav-link">
                    {item.label} <ExternalLink size={12} className="nav-ext" />
                  </a>
                ) : (
                  <Link to={item.to} className={`nav-link ${location.pathname === item.to ? 'active' : ''}`}>
                    {item.label}
                    {item.children && <ChevronDown size={13} className="nav-chev" />}
                  </Link>
                )}
                {item.children && (
                  <div className="dropdown">
                    {item.children.map((c) => (
                      <Link key={c.to} to={c.to} className="dropdown-link">{c.label}</Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          <button className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
            {mobileOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="mobile-menu">
          {NAV.map((item) => (
            <div key={item.label}>
              {item.href ? (
                <a href={item.href} target="_blank" rel="noreferrer" className="mobile-link">{item.label}</a>
              ) : item.children ? (
                <>
                  <button className="mobile-link mobile-sub-toggle" onClick={() => setOpenSub(openSub === item.label ? null : item.label)}>
                    {item.label} <ChevronDown size={16} style={{ transform: openSub === item.label ? 'rotate(180deg)' : 'none' }} />
                  </button>
                  {openSub === item.label && (
                    <div className="mobile-sub">
                      {item.children.map((c) => (
                        <Link key={c.to} to={c.to} className="mobile-link sub">{c.label}</Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link to={item.to} className="mobile-link">{item.label}</Link>
              )}
            </div>
          ))}
        </div>
      )}
    </header>
  );
}
